'use client';

import { useEffect } from 'react';

import { useCustomerAutoshipSubscriptions } from '@libs/common-next';

import { register, setValue, usePurchaseFormWatch } from '@/entities/purchase-form';
import { IconRecurring, RadioCard, RadioCardGroup } from '@/shared/ui';

import { getAutoshipLabel } from '../lib';
import { ImmediateDeliveryTitle } from './ImmediateDeliveryTitle';

export const Options = () => {
    const { autoshipData } = useCustomerAutoshipSubscriptions();
    const nextSubscriptionDate = autoshipData?.data?.nextSubscriptionDate;
    const subscriptionType = usePurchaseFormWatch('subscriptionType');
    const autoshipFrequency = usePurchaseFormWatch('autoshipFrequency');
    const isOneTimeFrequency = autoshipFrequency === 'one_time';

    useEffect(() => {
        if (isOneTimeFrequency) {
            setValue('subscriptionType', 'existing');
        }
    }, [isOneTimeFrequency]);

    return (
        <div className="fulfilment-selection-drawer__options">
            <RadioCardGroup>
                <RadioCard
                    value="new"
                    checked={subscriptionType === 'new'}
                    title={<ImmediateDeliveryTitle />}
                    id="fulfilment-immediate"
                    disabled={isOneTimeFrequency}
                    inputProps={{ ...register('subscriptionType'), disabled: isOneTimeFrequency }}
                />
                <RadioCard
                    value="existing"
                    checked={subscriptionType === 'existing'}
                    id="fulfilment-autoship"
                    iconSlot={<IconRecurring />}
                    title={getAutoshipLabel(nextSubscriptionDate)}
                    inputProps={{ ...register('subscriptionType') }}
                />
            </RadioCardGroup>
        </div>
    );
};
